import type { AdTriggerPhase } from '@/modules/adpopcorn-ssp';

//* 광고 트리거 버튼의 안내 문구 단일 진실 — 스크래치·이어서 열기·AdBonus가 동일 카피를 쓴다.
//* 소비처가 한 줄 높이를 예약해 두므로 모바일(typo-caption2)에서 줄바꿈되지 않는 길이를 유지한다.
//* (로또 응모 블로킹 오버레이도 같은 카피를 쓴다 — export)
export const AD_TRIGGER_PENDING_NOTICE = '광고를 준비하고 있어요';
export const AD_TRIGGER_COOLDOWN_NOTICE =
  '광고가 없어요. 잠시 후 다시 시도해 주세요';

//* pending/cooldown일 때의 공통 문구를 돌려주고, ready면 소비처별 문구(null)로 넘긴다.
export const resolveAdTriggerNotice = (
  phase: AdTriggerPhase,
): string | null => {
  if (phase === 'pending') {
    return AD_TRIGGER_PENDING_NOTICE;
  }
  if (phase === 'cooldown') {
    return AD_TRIGGER_COOLDOWN_NOTICE;
  }

  return null;
};
